<template>
    <component :is="version"></component>
</template>

<script>
import { mapGetters } from 'vuex';

const getters = [
    'is_collapsed',
];

export default {
    name: 'Stub',
    computed: {
        ...mapGetters(getters),
        version() {
            return this.is_collapsed ? 'MobileStub' : 'WideStub';
        },
    },
    components: {
        MobileStub: () => import('../components/stub/MobileStub'),
        WideStub: () => import('../components/stub/WideStub'),
    },
};
</script>
